export default __webpack_public_path__ + "static/media/sign-text-hover-icon.71e1ab5f.svg";